<template>
    <div>
        <div class="content-header text-center">
            <h2>Submit Support Ticket</h2>
        </div>
        <div class="container-fluid min-content-height" :class="togglequestion">
            <div class="row">
                <div class="col">
                    <div class="card card-body">
                        <form id="smtpform" v-on:submit.prevent="send_email">
                            <div class="mb-3">
                                <label for="email" class="form-label">Your Email Address</label>
                                <input type="email" class="form-control" id="email" name="email" aria-describedby="email" v-model="form.email">
                            </div>
                            <div class="mb-3">
                                <label for="subject" class="form-label">Which feature are you experiencing issues with?</label>
                                <select class="form-select form-select-lg mb-3" v-model="selectedIssue">
                                    <option value="">- Please make a selection -</option>
                                    <option value="dataset">Uploading a Dataset</option>
                                    <option value="prospect">Generating a Prospect List</option>
                                    <option value="emailappend">Appending Email Addresses</option>
                                    <option value="script">Custom Script Results</option>
                                    <option value="baseline">Custom Baseline</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div class="card card-body mb-3" v-if="this.selectedIssue == 'dataset'" id="datasetIssue">
                                    <h4>Dataset Uploads</h4>
                                    <label>If you were able to upload a Dataset, please select from the list:</label>

                                    <select class="form-select form-select-lg mb-3" v-model="form.dataset">
                                        <option v-for='(data, index) in datasets' :value="data">{{data}}</option>
                                    </select>

                                     <div  v-if="fileUploaded == false">
                                        <label>Otherwise upload the file here:</label>
                                        <input class="form-control" type="file" @change="uploadFile" />
                                    </div>

                                    <div v-if="fileUploaded">
                                        <p>File uploaded successfully! {{this.form.attachment}}</p>
                                    </div>
                                </div>

                                <div class="card card-body mb-3"  v-if="this.selectedIssue == 'prospect'" id="prospectIssues">
                                    <h4>Prospect Generator</h4>
                                    <label>If you were able to generate the prospect list, please select the file here:</label>
                                    
                                    <select class="form-select form-select-lg mb-3" v-model="form.prospect">
                                        <option v-for='(data, index) in prospects' :value="data">{{data}}</option>
                                    </select>

                                     <div  v-if="fileUploaded == false">
                                        <label>Otherwise upload the file here:</label>
                                        <input class="form-control" type="file" @change="uploadFile" />
                                    </div>

                                    <div v-if="fileUploaded">
                                        <p>File uploaded successfully! {{this.form.attachment}}</p>
                                    </div>

                                </div>

                                <div class="card card-body mb-3" v-if="this.selectedIssue == 'emailappend'" id="emailappendtoolIssue">
                                    <h4>Email Append</h4>
                                    <label>If you were able to generate an email append file and had issues with the results, please select from the list:</label>

                                    <select class="form-select form-select-lg mb-3" v-model="form.emailappend">
                                        <option v-for='(data, index) in emaillists' :value="data">{{data}}</option>
                                    </select>

                                    <div  v-if="fileUploaded == false">
                                        <label>Otherwise upload the file here:</label>
                                        <input class="form-control" type="file" @change="uploadFile" />
                                    </div>

                                    <div v-if="fileUploaded">
                                        <p>File uploaded successfully! {{this.form.attachment}}</p>
                                    </div>

                                </div>

                                <div class="card card-body mb-3" v-if="this.selectedIssue == 'script'" id="customscriptIssue">
                                    <h4>Issue with Custom Script Selected</h4>
                                </div>

                                <div class="card card-body mb-3" v-if="this.selectedIssue == 'baseline'" id="custombaselineIssue">
                                    <h4>Using or Generating a Custom Baseline Selected</h4>
                                </div>
                            <div class="mb-3">
                                <label for="message" class="form-label">Please describe the issue in as much detail as possible:</label>
                                <textarea class="form-control" id="message" name="message" aria-describedby="message" v-model="form.message"  rows="10"></textarea>
                            </div>
                            <button type="submit" class="btn btn-primary">Submit Ticket Request {{this.ticketnumber}}</button>
                        </form>
                    
                    </div>
                </div>
                
            </div>
            
        </div>
        <div class="container-fluid min-content-height" :class="toggleanswer">
            <h3>Thank you!</h3> 
            <p class="lead">Your request has been submitted, and assigned to Ticket number: {{ ticketnumber }}</p>
            <p class="lead">You will receive an email to verify this ticket submission, and will be contacted for any follow up questions, updates or when the issue is resolved as soon as possible.</p>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Support Ticket',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            form: {
                email: '',
                subject: '',
                message: '',
                dataset: '',
                emailappend: '',
                prospect: '',
                attachment: ''
            },
            datasets: [],
            prospects: [],
            emaillists: [],
            toggleanswer: 'd-none',
            togglequestion: 'd-block',
            ticketnumber: '',
            selectedIssue: '',
            selectedFile: null,
            fileUploaded: false
        }
    },
     methods: { 
        handleFileUpload(event) {
            this.selectedFile = event.target.files[0];
        },
        uploadFile(event) {
            event.preventDefault();
            this.handleFileUpload(event);
            if (!this.selectedFile) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            axios.post('/add_attachment', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                })
                .then(response => {
                    console.log(response.data);
                    this.form.attachment = response.data;
                    this.fileUploaded = true;
                })
                .catch(error => {
                    console.error(error);
                });
            },
        get_datasets() {
            axios({
            method : 'POST',
            url : '/list_datasets',
            data:'',
            }).then(
            (response) => {
                this.datasets = processDatasets(response.data);
                this.prospects = processProspects(response.data);
                // console.log('process datasets list '+response.data);
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        get_emailappends() {
            axios({
                method : 'POST',
                url : '/list_emaillists',
                data:'',
            }).then(response => {
                this.emaillists = processEmails(response.data);
                console.log('test EMAIL APPENDS email response: '+this.emaillists);
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
        },
        generate_ticket() {
            axios.get('/get_support_ticket')
            .then(
            (response) => {
                this.ticketnumber = response.data;
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        send_email() {
            var finsubject = '';
            if(this.selectedIssue == 'dataset') {
                finsubject = 'Dataset Upload Issue';
            } else if(this.selectedIssue == 'prospect') {
                finsubject = 'Prospect Generator Issue';
            } else if(this.selectedIssue == 'emailappend') {
                finsubject = 'Email Append Tool Issue';
            } else if(this.selectedIssue == 'script') {
                finsubject = 'Issue with Custom Script';
            } else if(this.selectedIssue == 'baseline') {
                finsubject = 'Using or Generating a Custom Baseline';
            } else if(this.selectedIssue == 'other') {
                finsubject = 'Other/Misc Issue';
            };
            console.log('prospect value: '+this.form.prospect);
            console.log('dataset value: '+this.form.dataset);
            console.log('email append value: '+this.form.emailappend);
            const now = new Date();
            const initialtext = `<strong>Subject:</strong> ${finsubject}%0D%0A
                <strong>Email:</strong> ${this.form.email}%0D%0A
                <strong>Name:</strong> ${this.userData.name}%0D%0A
                <strong>User UID:</strong> ${this.userData.uid}%0D%0A
                <strong>Ticket Number:</strong> ${this.ticketnumber}%0D%0A
                <strong>Submitted:</strong> ${now}<hr>%0D%0A
                %0D%0A
            ${this.form.message}%0D%0A
            %0D%0A
            ${this.form.prospect ? `<hr><strong>Prospect file:</strong> ${this.form.prospect}%0D%0A` : ''}
            ${this.form.dataset ? `<hr><strong>Dataset file:</strong> ${this.form.dataset}%0D%0A` : ''}
            ${this.form.emailappend ? `<hr><strong>Email Append file:</strong> ${this.form.emailappend}%0D%0A` : ''}
            
            ${this.form.attachment ? `<hr><strong>File Attached: </strong>%0D%0A` : ''}`;
            axios.get('/send_email',  {params: {email: "alan.fleming@analyzecorp.com,amanda.gilcreast@analyzecorp.com, ", subject: "Analyze Support Request "+this.form.email+" Ticket: "+this.ticketnumber, message: initialtext, attachment: this.form.attachment }})
            .then(
            (response) => {
                this.send_notification();
                this.toggleanswer = 'd-block';
                this.togglequestion = 'd-none';
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        send_notification() {
            const themsg = "Thank you for contacting the Analyze Support Team. Our team is looking into your request right now and will contact you if we need any additional information, or when there are any updates available. Our support team is available Monday - Friday, 9:30am - 4:30pm ET. If you need immediate support, please call 703-273-1900. Thank you for your patience and we will be in touch."
            axios.get('/send_email',  {params: {email: this.form.email, subject: "Analyze360 Support Request", message: themsg }})
            .then(
            (response) => {
                // console.log('Email Sent: '+JSON.stringify(response.data));
                //this.$emit('customChange', {shell: 'SMTPTest', dataset: ''});
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        }  
    },
    watch: {
        selectedIssue(newValue) {
            this.form.subject = this.$el.querySelector('select option:checked').text
        },
        selectedDataset(newValue) {
            this.form.dataset = this.$el.querySelector('select option:checked').text
        },
        selectedProspect(newValue) {
            this.form.prospect = this.$el.querySelector('select option:checked').text
        },
        selectedEmailappend(newValue) {
            this.form.emailappend = this.$el.querySelector('select option:checked').text
        }
    },
    mounted() {
        this.generate_ticket();
        this.get_datasets();
        // this.get_emailappends();
        axios({
            method : 'POST',
            url : '/list_emaillists_bulk',
            data:'',
        }).then(response => {
            this.emaillists = processEmails(response.data);
            console.log('test EMAIL APPENDS email response: '+this.emaillists);
        }).catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    }
};
function processDatasets(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect') || b[i].includes('baseline'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
};
function processProspects(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || !b[i].includes('prospect'))
          continue;
            iH.push(b[i]);
      };
      return iH;
};
function processEmails(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        iH.push(b[i]);
      };
      return iH;
};
</script>